var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view != null)?_c(_vm.rolComponent[_vm.view].component,{tag:"component"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }